<template>
  <q-page>
    <q-table
      :data="history"
      :columns="columnsOnView()"
      row-key="id"
      flat
      :pagination.sync="pagination"
      :loading="loading"
      @request="request"
      :rows-per-page-options="[5, 10, 50, 100]"
    >
      <template slot="top">
        <q-search class="q-my-md" v-model="search" @keyup.enter="request({ pagination })" />
      </template>

      <template slot="body-cell-status_from" slot-scope="props">
          <q-td :props="props">
              <q-chip 
                  class="full-width"
                  :icon="getRedeemStatusIcon(props.row.status_from)"
                  :color="getRedeemStatusColor(props.row.status_from)">
                  {{ getRedeemStatus(props.row.status_from) || '-' }}
              </q-chip>
          </q-td>
      </template>

      <template slot="body-cell-status_to" slot-scope="props">
          <q-td :props="props">
              <q-chip
                  class="full-width"
                  :icon="getRedeemStatusIcon(props.row.status_to)"
                  :color="getRedeemStatusColor(props.row.status_to)">
                  {{ getRedeemStatus(props.row.status_to) || '-' }}
              </q-chip>
          </q-td>
      </template>

      <q-tr slot="bottom-row">
        <q-td colspan="100%">
            <q-btn
                flat
                round
                dense
                color="secondary"
                size="small"
                icon="far fa-cog"
                @click="show_modal = true"
            >
                <q-tooltip>
                    {{ $t('configure_table_tooltip') }}
                </q-tooltip>
            </q-btn>
        </q-td>
      </q-tr>
    </q-table>

    <q-modal
			v-model="show_modal"
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="saveColumns()" icon="fas fa-times" />
					<q-toolbar-title>
						{{ $t('personalize_columns') }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<div class="row gutter-md">
						<div
							class="col-xs-12 col-sm-4"
							v-for="(column, index) in columns"
							:key="index"
							v-if="column.name !== 'actions' && column.name !== 'id'"
						>
							<q-checkbox v-model="column.show" :label="$t(column.label)" />
						</div>
					</div>

					<div class="row reverse gutter-md q-mt-md">
						<div class="col-xs-12 col-sm-3">
							<q-btn
								icon="fal fa-times"
								color="primary"
								class="fit"
								:label="$t('close')"
								@click="saveColumns()"
							/>
						</div>
					</div>
				</div>
			</q-modal-layout>
		</q-modal>

  </q-page>
</template>

<script>
import { mapGetters } from 'vuex';
import formatDate from './utils/formatDate';
import { getRedeemStatus, getRedeemStatusColor, getRedeemStatusIcon } from './utils/statusBadge';

export default {
  name: 'RedeemHistory',

  data () {
    return {
      columns: [
        { id: 1, name: 'reward_user_redemption', label: '#', field: 'reward_user_redemption', align: 'left', sortable: true, show: true },
        { id: 2, name: 'redeemed_user_id', label: 'ID aprovador', field: 'user_approver_id', align: 'left', sortable: true, show: true },
        { id: 3, name: 'redeemed_user_email', label: 'Email do usuário', field: 'redeemed_user_email', align: 'left', sortable: true, show: true },
        { id: 4, name: 'redemption_price', label: 'Valor', field: 'redemption_price', align: 'left', sortable: true, show: true },
        { id: 5, name: 'created_date', label: 'Data do resgate', field: 'created_date', align: 'left', sortable: true, show: true },
        { id: 6, name: 'status_from', label: 'Status De', field: 'status_from', align: 'left', sortable: true, show: true },
        { id: 7, name: 'status_to', label: 'Status Para', field: 'status_to', align: 'left', sortable: true, show: true },
        { id: 8, name: 'user_approver_id', label: 'ID do aprovador', field: 'user_approver_id', align: 'left', sortable: true, show: true },
        { id: 9, name: 'user_approver_email', label: 'Email do aprovador', field: 'user_approver_email', align: 'left', sortable: true, show: true },
        { id: 10, name: 'justification', label: 'Justificativa', field: 'justification', align: 'left', sortable: true, show: true },
        { id: 11, name: 'internal_comment', label: 'Observação interna', field: 'internal_comment', align: 'left', sortable: true, show: true },
      ],
      pagination: {
          page: 1,
          rowsPerPage: 10,
          rowsNumber: 0,
          sortBy: null,
      },
      history: [],
      loading: false,
      search: '',
      show_modal: false,
    }
  },

  computed: {
    ...mapGetters({
          access_token: 'common/access_token',
          user_clients: 'common/user_clients',
          areas: 'registration_lists/country_areas',
          user_groups: 'registration_lists/group_users',
          profiles: 'registration_lists/profiles',
          tags: 'registration_lists/tags',
          reports: 'registration_lists/reports',
          num_rows: 'datatable/num_rows',
          redeem_history_columns: 'datatable_columns/redeem_history_columns',
      }),

      getHeader() {
          let headers = {}
          return headers = {
              headers: {
                  'content-type': 'application/json',
                  'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                  'authorization': 'Bearer ' + this.access_token
              }
          }
      }
  },

  methods: {
    getRedeemStatus,
    getRedeemStatusColor,
    getRedeemStatusIcon,

    columnsOnView() {
      return this.columns.filter(c => this.redeem_history_columns.includes(c.id))
    },

    saveDatatableColumns() {
        if (this.columns.filter(c => c.show).length == 0)
          this.$store.dispatch('datatable_columns/SET_REDEEM_HISTORY_COLUMNS', [this.columns.map(c => c.id)])
        else
          this.$store.dispatch('datatable_columns/SET_REDEEM_HISTORY_COLUMNS', [this.columns.filter(c => c.show || c.name === 'actions').map(c => c.id)])
		},

    saveColumns() {
			this.show_modal = false
			this.saveDatatableColumns()
		},

    async request({ pagination }) {
      this.$q.loading.show()

      const { page, rowsPerPage, sortBy, descending } = pagination
      this.pagination = pagination

      await this.$axios.get(`admin_rewards_store/reward_user_redemption_history/`, {
          ...this.getHeader,
          params: {
              page: page,
              page_size: rowsPerPage,
              ordering: sortBy ? (descending ? '-' + sortBy : sortBy) : null,
              ...(this.search ? { search: this.search } : {}),
          }
      })
      .then(response => {
              this.show_report_reward = true
              this.history = response.data.results.map(r => {
                  return {
                      ...r,
                      created_date: r.created_date ? formatDate(r.created_date, this.id_user_language_selected) : null,
                  }
              })
              this.$q.loading.hide()
          })
      .catch(e => {
          this.$q.loading.hide()
          console.log(e)
      })
    },
  },

  created() {
      if (this.redeem_history_columns.length == 0) {
        this.$store.dispatch('datatable_columns/SET_REDEEM_HISTORY_COLUMNS', [this.columns.map(c => c.id)])
      } else {
          this.columns = this.columns.map(c => {
              if (this.redeem_history_columns.includes(c.id) || c.name === 'actions') return { ...c, show: true }
              else return { ...c, show: false }
          })
      }
  },

  mounted() {
    this.request({ pagination: this.pagination })
  }
}
</script>